export const images = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733491/travesia/2026/wpekvbjwzmpsnklastyb.jpg",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/2026/l1nvbvbt42pg3qeugu0a.jpg",
  },

  {
    id: 3,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/2026/p9jsfdeqhzfhi4yud10r.jpg",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1747682863/travesia/2026/g0cbdol4y2toclqbbqc0.jpg",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733492/travesia/2026/lvubt8gku7n95ilkeqtt.jpg",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/2026/anjwkwrntnfe60hzexho.jpg",
  },
];

export const imgHeaderTravesiaCatedral =
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/2026/tngi8mvge2rbiltucnof.jpg";

export const tabletImages = [
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/2026/tngi8mvge2rbiltucnof.jpg",
];

export const imgUno =
  "https://res.cloudinary.com/dja5ahopr/image/upload/v1746733493/travesia/2026/tngi8mvge2rbiltucnof.jpg";
